let publications = [
    {
        "title": "An Ultrastable Aqueous Iodine-Hydrogen Gas Battery",
        "author": "Zhengxin Zhu, Yahan Meng, Yi Cui, Wei Chen*",
        "year": 2021,
        "journal": "Advanced Functional Materials",
        "volumn": "",
        "issue": "",
        "pages": "2101024",
        "doi": "https://doi.org/10.1002/adfm.202101024"
    },
    {
        "title": "Challenges and strategies on Zn electrodeposition for stable Zn-ion batteries",
        "author": "Xinhua Zheng, Touqeer Ahmad, Wei Chen*",
        "year": 2021,
        "journal": "Energy Storage Materials",
        "volumn": "39",
        "issue": "",
        "pages": "365-394",
        "doi": "https://doi.org/10.1016/j.ensm.2021.04.027"
    }, {
        "title": "Recent Progress in High-Entropy Alloys for Catalysts: Synthesis, Applications, and Prospects",
        "author": "Ke Li, Wei Chen*",
        "year": 2021,
        "journal": "Materials Today Energy",
        "volumn": "",
        "issue": "20",
        "pages": "100638",
        "doi": "https://doi.org/10.1016/j.mtener.2021.100638"
    },
    {
        "title": "Opportunities of Aqueous Manganese-Based Batteries with Deposition and Stripping Chemistry",
        "author": "Mingming Wang, Xinhua Zheng, Xiang Zhang, Dongliang Chao, Shi-Zhang Qiao, Husam N. Alshareef, Yi Cui*, Wei Chen*",
        "year": 2021,
        "journal": "Advanced Energy Materials",
        "volumn": "11",
        "issue": "5",
        "pages": "2002904",
        "url": "<Go to ISI>://WOS:000600499100001",
        "doi": "10.1002/aenm.202002904"
    },
    {
        "title": "A High Performance Aqueous Iron-Hydrogen Gas Battery",
        "author": "Zhengxin Zhu, Yahan Meng, Mingming Wang, Yichen Yin, Wei Chen*",
        "year": 2021,
        "journal": "Materials Today Energy",
        "volumn": "19",
        "issue": "",
        "pages": "100603",
        "url": "",
        "doi": "https://doi.org/10.1016/j.mtener.2020.100603"
    },
    {
        "title": "Lithium Intercalation Compounds-Hydrogen Gas Batteries",
        "author": "Zhengxin Zhu, Xiang Zhang, Mingming Wang, Wei Chen*",
        "year": 2021,
        "journal": "Chemical Journal of Chinese Universities",
        "volumn": "42",
        "issue": "2",
        "pages": "1-9",
        "url": "",
        "doi": "https://doi.org/10.7503/cjcu20200514"
    },
    {
        "title": "In Vivo Polymerization (\"Hard-Wiring\") of Bioanodes Enables Rapid Start-Up and Order-of-Magnitude Higher Power Density in a Microbial Battery",
        "author": "Kristian Dubrawski, Sungguen Woo, Wei Chen, Xing Xie, Yi Cui*, Craig S. Criddle*",
        "year": 2020,
        "journal": "Environmental Science & Technology",
        "volumn": "54",
        "issue": "22",
        "pages": "14732-14739",
        "url": "<Go to ISI>://WOS:000592863400060",
        "doi": "https://doi.org/10.1021/acs.est.0c05000"
    },
    {
        "title": "Revealing Molecular Mechanisms in Hierarchical Nanoporous Carbon via Nuclear Magnetic Resonance",
        "author": "Haiyan Mao#, Jing Tang#, Jun Xu, Yucan Peng, Jun Chen, Bing Wu, Yuanwen Jiang, Kaipeng Hou, Shuo Chen, Jiangyan Wang, Hye Ryoung Lee, David M. Halat, Bing Zhang, Wei Chen, Ariel Z. Plantz, Zhiyi Lu, Yi Cui*, Jeffrey A. Reimer*",
        "year": 2020,
        "journal": "Matter",
        "volumn": "3",
        "issue": "6",
        "pages": "2093-2107",
        "url": "<Go to ISI>://WOS:000598228500008",
        "doi": "10.1016/j.matt.2020.09.024"
    },
    {
        "title": "A High-Rate Lithium Manganese Oxide-Hydrogen Battery",
        "author": "Zhengxin Zhu, Mingming Wang, Yahan Meng, Zihan Lin, Yi Cui*, Wei Chen*",
        "year": 2020,
        "journal": "Nano Letters",
        "volumn": "20",
        "issue": "5",
        "pages": "3278-3283",
        "url": "<Go to ISI>://WOS:000535255300044",
        "doi": "10.1021/acs.nanolett.0c00044"
    },
    {
        "title": "Membrane-Free Zn/MnO2 Flow Battery for Large-Scale Energy Storage",
        "author": "Guodong Li#, Wei Chen#, Hao Zhang#, Yongji Gong, Feifei Shi, Jiangyan Wang, Rufan Zhang, Guangxu Chen, Yang Jin, Tong Wu, Zhiyong Tang, Yi Cui*",
        "year": 2020,
        "journal": "Advanced Energy Materials",
        "volumn": "10",
        "issue": "9",
        "pages": "1902085",
        "url": "<Go to ISI>://WOS:000510226100001",
        "doi": "10.1002/aenm.201902085"
    },
    {
        "title": "Highly Stable Phosphonate-Based MOFs with Engineered Bandgaps for Efficient Photocatalytic Hydrogen Production",
        "author": "Yun-Pei Zhu, Jun Yin, Edy Abou-Hamad, Xiaokang Liu, Wei Chen, Tao Yao, Omar F. Mohammed, and Husam N. Alshareef*",
        "year": 2020,
        "journal": "Advanced Materials",
        "volumn": "32",
        "issue": "16",
        "pages": "1906368",
        "url": "<Go to ISI>://WOS:000529881300031",
        "doi": "10.1002/adma.201906368"
    },
    {
        "title": "Solubility-Dependent Protective Effects of Binary Alloys for Lithium Anode",
        "author": "Yan Xu, Shuyang Zhao, Guangmin Zhou, Wei Chen, Fei Zhou, Ze Rong, Yang Wu, Jia Li, Jinghua Guo*, Yuegang Zhang*",
        "year": 2020,
        "journal": "ACS Applied Energy Materials",
        "volumn": "3",
        "issue": "3",
        "pages": "2278-2284",
        "url": "<Go to ISI>://WOS:000526598300027",
        "doi": "10.1021/acsaem.9b02125"
    },
    {
        "title": "Synergistic Enhancement of Electrocatalytic CO2 Reduction to C2 Oxygenates at Nitrogen-Doped Nanodiamonds/Cu Interface",
        "author": "Hongxia Wang#, Yan-Kai Tzeng#, Yongfei Ji#, Yanbin Li, Jun Li, Xueli Zheng, Ankun Yang, Yayuan Liu, Yongji Gong, Lili Cai, Yuzhang Li, Xiaokun Zhang, Wei Chen, Bofei Liu, Haiyu Lu, Nicholas A. Melosh, Zhi-Xun Shen, Karen Chan*, Tianwei Tan*, Steven Chu*, Yi Cui*",
        "year": 2020,
        "journal": "Nature Nanotechnology",
        "volumn": "15",
        "issue": "",
        "pages": "131-137",
        "url": "",
        "doi": "https://doi.org/10.1038/s41565-019-0603-y"
    },
    {
        "title": "A Two-Dimensional MoS2 Catalysis Transistor by Solid-State Ion Gating Manipulation and Adjustment (SIGMA)",
        "author": "Yecun Wu, Stefan Ringe, Chun-Lan Wu, Wei Chen, Ankun Yang, Hao Chen, Michael Tang, Guangmin Zhou, Harold Y. Hwang, Karen Chan*, Yi Cui*",
        "year": 2019,
        "journal": "Nano Letters",
        "volumn": "19",
        "issue": "10",
        "pages": "7293-7300",
        "url": "<Go to ISI>://WOS:000490353500074",
        "doi": "10.1021/acs.nanolett.9b02888"
    },
    {
        "title": "Self-Selective Catalyst Synthesis for CO2 Reduction",
        "author": "Hongxia Wang#, Zheng Liang#*, Michael Tang#, Guangxu Chen, Yanbin Li, Wei Chen, Dingchang Lin, Zewen Zhang, Guangmin Zhou, Jun Li, Zhiyi Lu, Karen Chan*, Tianwei Tan*, Yi Cui*",
        "year": 2019,
        "journal": "Joule",
        "volumn": "3",
        "issue": "8",
        "pages": "1927-1936",
        "url": "<Go to ISI>://WOS:000482204600015",
        "doi": "10.1016/j.joule.2019.05.023"
    },

    {
        "title": "Ultrathin, flexible, solid polymer composite electrolyte enabled with aligned nanoporous host for lithium batteries",
        "author": "Jiayu Wan#, Jin Xie#, Xian Kong, Zhe Liu, Kai Liu, Feifei Shi, Allen Pei, Hao Chen, Wei Chen, Jun Chen, Xiaokun Zhang, Linqi Zong, Jiangyan Wang, Long-Qing Chen, Jian Qin, Yi Cui*",
        "year": 2019,
        "journal": "Nature Nanotechnology",
        "volumn": "14",
        "issue": "7",
        "pages": "705-711",
        "url": "<Go to ISI>://WOS:000473760300023",
        "doi": "10.1038/s41565-019-0465-3"
    },
    {
        "title": "Fast lithium growth and short circuit induced by localized-temperature hotspots in lithium batteries",
        "author": "Yangying Zhu#, Jin Xie#, Allen Pei, Bofei Liu, Yecun Wu, Dingchang Lin, Jun Li, Hansen Wang, Hao Chen, Jinwei Xu, Ankun Yang, Chun-Lan Wu, Hongxia Wang, Wei Chen, Yi Cui*",
        "year": 2019,
        "journal": "Nature Communications",
        "volumn": "10",
        "issue": "1",
        "pages": "2067",
        "url": "<Go to ISI>://WOS:000466871300003",
        "doi": "10.1038/s41467-019-09924-1"
    },
    {
        "title": "Surface-engineered mesoporous silicon microparticles as high-Coulombic-efficiency anodes for lithium-ion batteries",
        "author": "Jiangyan Wang, Lei Liao, HyeRyoung Lee, Feifei Shi, William Huang, Jie Zhao, Allen Pei, Jing Tang, Xueli Zheng, Wei Chen, Yi Cui*",
        "year": 2019,
        "journal": "Nano Energy",
        "volumn": "61",
        "issue": "",
        "pages": "404-410",
        "url": "<Go to ISI>://WOS:000471201800048",
        "doi": "10.1016/j.nanoen.2019.04.070"
    },
    {
        "title": "Breathing-Mimicking Electrocatalysis for Oxygen Evolution and Reduction",
        "author": "Jun Li, Yangying Zhu, Wei Chen, Zhiyi Lu, Jinwei Xu, Allen Pei, Yucan Peng, Xueli Zheng, Zewen Zhang, Steven Chu, Yi Cui*",
        "year": 2019,
        "journal": "Joule",
        "volumn": "3",
        "issue": "2",
        "pages": "557-569",
        "url": "<Go to ISI>://WOS:000460076100021",
        "doi": "10.1016/j.joule.2018.11.015"
    },
    {
        "title": "A manganese-hydrogen battery with potential for grid-scale energy storage",
        "author": "Wei Chen#, Guodong Li#, Allen Pei, Yuzhang Li, Lei Liao, Hongxia Wang, Jiayu Wan, Zheng Liang, Guangxu Chen, Hao Zhang, Jiangyan Wang, Yi Cui*",
        "year": 2018,
        "journal": "Nature Energy",
        "volumn": "3",
        "issue": "5",
        "pages": "428-435",
        "url": "<Go to ISI>://WOS:000433029700018",
        "doi": "10.1038/s41560-018-0147-7"
    },
    {
        "title": "Nickel-hydrogen batteries for large-scale energy storage",
        "author": "Wei Chen, Yang Jin, Jie Zhao, Nian Liu, Yi Cui*",
        "year": 2018,
        "journal": "Proceedings of the National Academy of Sciences of the United States of America",
        "volumn": "115",
        "issue": "46",
        "pages": "11694-11699",
        "url": "<Go to ISI>://WOS:000449934400032",
        "doi": "10.1073/pnas.1809344115"
    },
    {
        "title": "An Aqueous Inorganic Polymer Binder for High Performance Lithium-Sulfur Batteries with Flame-Retardant Properties",
        "author": "Guangmin Zhou#, Kai Liu#, Yanchen Fan#, Mengqi Yuan, Bofei Liu, Wei Liu, Feifei Shi, Yayuan Liu, Wei Chen, Jeffrey Lopez, Denys Zhuo, Jie Zhao, Yuchi Tsao, Xuanyi Huang, Qianfan Zhang*, Yi Cui*",
        "year": 2018,
        "journal": "ACS Central Science",
        "volumn": "4",
        "issue": "2",
        "pages": "260-267",
        "url": "<Go to ISI>://WOS:000426613700018",
        "doi": "10.1021/acscentsci.7b00569"
    },
    {
        "title": "Electrocatalytic N-Doped Graphitic Nanofiber - Metal/Metal Oxide Nanoparticle Composites",
        "author": "Hongjie Tang#, Wei Chen#, Jiangyan Wang, Thomas Dugger, Luz Cruz, David Kisailus*",
        "year": 2018,
        "journal": "Small",
        "volumn": "14",
        "issue": "11",
        "pages": "1703459",
        "url": "<Go to ISI>://WOS:000427592400010",
        "doi": "10.1002/smll.201703459"
    },
    {
        "title": "In Situ Investigation on the Nanoscale Capture and Evolution of Aerosols on Nanofibers",
        "author": "Rufan Zhang, Bofei Liu, Ankun Yang, Yangying Zhu, Chong Liu, Guangmin Zhou, Jie Sun, Po-Chun Hsu, Wenting Zhao, Dingchang Lin, Yayuan Liu, Allen Pei, Jin Xie, Wei Chen, Jinwei Xu, Yang Jin, Tong Wu, Xuanyi Huang, Yi Cui*",
        "year": 2018,
        "journal": "Nano Letters",
        "volumn": "18",
        "issue": "2",
        "pages": "1130-1138",
        "url": "<Go to ISI>://WOS:000425559700068",
        "doi": "10.1021/acs.nanolett.7b04673"
    },



    {
        "title": "Reactivation of dead sulfide species in lithium polysulfide flow battery for grid scale energy storage",
        "author": "Yang Jin#, Guangmin Zhou#, Feifei Shi, Denys Zhuo, Jie Zhao, Kai Liu, Yayuan Liu, Chenxi Zu, Wei Chen, Rufan Zhang, Xuanyi Huang, Yi Cui*",
        "year": 2017,
        "journal": "Nature Communications",
        "volumn": "8",
        "issue": "",
        "pages": "462",
        "url": "<Go to ISI>://WOS:000409458000016",
        "doi": "10.1038/s41467-017-00537-0"
    },
    {
        "title": "Sulfiphilic Nickel Phosphosulfide Enabled Li2S Impregnation in 3D Graphene Cages for Li-S Batteries",
        "author": "Guangmin Zhou, Jie Sun, Yang Jin, Wei Chen, Chenxi Zu, Rufan Zhang, Yongcai Qiu, Jie Zhao, Denys Zhuo, Yayuan Liu, Xinyong Tao, Wei Liu, Hye Ryoung Lee, Yi Cui*",
        "year": 2017,
        "journal": "Advanced Materials",
        "volumn": "29",
        "issue": "12",
        "pages": "1603366",
        "url": "<Go to ISI>://WOS:000396998800001",
        "doi": "10.1002/adma.201603366"
    },
    {
        "title": "Conformal Lithium Fluoride Protection Layer on Three-Dimensional Lithium by Nonhazardous Gaseous Reagent Freon",
        "author": "Dingchang Lin, Yayuan Liu, Wei Chen, Guangmin Zhou, Kai Liu, Bruce S Dunn, Yi Cui*",
        "year": 2017,
        "journal": "Nano Letters",
        "volumn": "17",
        "issue": "6",
        "pages": "3731-3737",
        "url": "<Go to ISI>://WOS:000403631600060",
        "doi": "10.1021/acs.nanolett.7b01020"
    },
    {
        "title": "In Situ Electrochemically Derived Nanoporous Oxides from Transition Metal Dichalcogenides for Active Oxygen Evolution Catalysts",
        "author": "Wei Chen, Yayuan Liu, Yuzhang Li, Jie Sun, Yongcai Qiu, Chong Liu, Guangmin  Zhou, Yi Cui*",
        "year": 2016,
        "journal": "Nano Letters",
        "volumn": "16",
        "issue": "12",
        "pages": "7588-7596",
        "url": "<Go to ISI>://WOS:000389963200040",
        "doi": "10.1021/acs.nanolett.6b03458"
    },
    {
        "title": "Efficient solar-driven water splitting by nanocone BiVO4-perovskite tandem cells",
        "author": "Yongcai Qiu#, Wei Liu#, Wei Chen#, Wei Chen#, Guangmin Zhou, Po-Chun Hsu, Rufan Zhang, Zheng Liang, Shoushan Fan, Yuegang Zhang*, Yi Cui*",
        "year": 2016,
        "journal": "Science Advances",
        "volumn": "2",
        "issue": "6",
        "pages": "1501764",
        "url": "<Go to ISI>://WOS:000380073800012",
        "doi": "10.1126/sciadv.1501764"
    },

    {
        "title": "Enhanced Intrinsic Catalytic Activity of lambda-MnO2 by Electrochemical Tuning and Oxygen Vacancy Generation",
        "author": "Sanghan Lee, Gyutae Nam, Jie Sun, Jang-Soo Lee, Hyun‐Wook Lee, Wei Chen, Jaephil Cho*, Yi Cui*",
        "year": 2016,
        "journal": "Angewandte Chemie-International Edition",
        "volumn": "55",
        "issue": "30",
        "pages": "8599-8604",
        "url": "<Go to ISI>://WOS:000383253500018",
        "doi": "10.1002/anie.201602851"
    },
    {
        "title": "Composites of a Prussian Blue Analogue and Gelatin-Derived Nitrogen-Doped Carbon-Supported Porous Spinel Oxides as Electrocatalysts for a Zn-Air Battery",
        "author": "Jang-Soo Lee, Gyutae Nam, Jie Sun, Shougo Higashi, Hyun‐Wook Lee, Sanghan Lee, Wei Chen, Yi Cui*, Jaephil Cho*",
        "year": 2016,
        "journal": "Advanced Energy Materials",
        "volumn": "6",
        "issue": "22",
        "pages": "1601052",
        "url": "<Go to ISI>://WOS:000388993100007",
        "doi": "10.1002/aenm.201601052"
    },
    {
        "title": "In Situ Electrochemical Oxidation Tuning of Transition Metal Disulfides to Oxides for Enhanced Water Oxidation",
        "author": "Wei Chen, Haotian Wang, Yuzhang Li, Yayuan Liu, Jie Sun, Sanghan Lee, Jangsoo Lee, Yi Cui*",
        "year": 2015,
        "journal": "ACS Central Science",
        "volumn": "1",
        "issue": "5",
        "pages": "244-251",
        "url": "<Go to ISI>://WOS:000365968800007",
        "doi": "10.1021/acscentsci.5b00227"
    },
    {
        "title": "Graphene based integrated tandem supercapacitors fabricated directly on separators",
        "author": "Wei Chen, Chuan Xia, H. N. Alshareef*",
        "year": 2015,
        "journal": "Nano Energy",
        "volumn": "15",
        "issue": "",
        "pages": "1-8",
        "url": "<Go to ISI>://WOS:000364578900001",
        "doi": "10.1016/j.nanoen.2015.03.040"
    },
    {
        "title": "Highly Stable Supercapacitors with Conducting Polymer Core-Shell Electrodes for Energy Storage Applications",
        "author": "Chuan Xia#, Wei Chen#, H. N. Alshareef*",
        "year": 2015,
        "journal": "Advanced Energy Materials",
        "volumn": "5",
        "issue": "8",
        "pages": "1401805",
        "url": "<Go to ISI>://WOS:000353357600003",
        "doi": "10.1002/aenm.201401805"
    },

    {
        "title": "Electrochemical tuning of olivine-type lithium transition-metal phosphates as efficient water oxidation catalysts",
        "author": "Yayuan Liu, Haotian Wang, Dingchang Lin, Chong Liu, Po-chun Hsu, Wei Liu, Wei Chen, Yi Cui*",
        "year": 2015,
        "journal": "Energy & Environmental Science",
        "volumn": "8",
        "issue": "6",
        "pages": "1719-1724",
        "url": "<Go to ISI>://WOS:000355985700011",
        "doi": "10.1039/c5ee01290b"
    },
    {
        "title": "One-Step Electrodeposited Nickel Cobalt Sulfide Nanosheet Arrays for High-Performance Asymmetric Supercapacitors",
        "author": "Wei Chen, Chuan Xia, H. N. Alshareef*",
        "year": 2014,
        "journal": "ACS Nano",
        "volumn": "8",
        "issue": "9",
        "pages": "9531-9541",
        "url": "<Go to ISI>://WOS:000342184400086",
        "doi": "10.1021/nn503814y"
    },
    {
        "title": "Morphological and Electrochemical Cycling Effects in MnO2 Nanostructures by 3D Electron Tomography",
        "author": "Wei Chen, R. B. Rakhi, Qingxiao Wang, M. N. Hedhili, H. N. Alshareef*",
        "year": 2014,
        "journal": "Advanced Functional Materials",
        "volumn": "24",
        "issue": "21",
        "pages": "3130-3143",
        "url": "<Go to ISI>://WOS:000337489400008",
        "doi": "10.1002/adfm.201303508"
    },
    {
        "title": "A general approach toward enhancement of pseudocapacitive performance of conducting polymers by redox-active electrolytes",
        "author": "Wei Chen, Chuan Xia, R. B. Rakhi, H. N. Alshareef*",
        "year": 2014,
        "journal": "Journal of Power Sources",
        "volumn": "267",
        "issue": "",
        "pages": "521-526",
        "url": "<Go to ISI>://WOS:000339601800060",
        "doi": "10.1016/j.jpowsour.2014.05.131"
    },
    {
        "title": "Shape-controlled porous nanocarbons for high performance supercapacitors",
        "author": "Wei Chen, R. B. Rakhi, M. N. Hedhili, H. N. Alshareef*",
        "year": 2014,
        "journal": "Journal of Materials Chemistry A",
        "volumn": "2",
        "issue": "15",
        "pages": "5236-5243",
        "url": "<Go to ISI>://WOS:000333101600010",
        "doi": "10.1039/c3ta15245f"
    },

    {
        "title": "Enhanced Rate Performance of Mesoporous Co3O4 Nanosheet Supercapacitor Electrodes by Hydrous RuO2 Nanoparticle Decoration",
        "author": "R. B. Rakhi, Wei Chen, Mohamed Nejib Hedhili, Dongkyu Cha, H. N. Alshareef*",
        "year": 2014,
        "journal": "ACS Applied Materials & Interfaces",
        "volumn": "6",
        "issue": "6",
        "pages": "4196-4206",
        "url": "",
        "doi": "https://doi.org/10.1021/am405849n"
    },
    {
        "title": "SnO2 Anode Surface Passivation by Atomic Layer Deposited HfO2 Improves Li-Ion Battery Performance",
        "author": "Nulati Yesibolati, Muhammad Shahid, Wei Chen, M. N. Hedhili, M. C. Reuter, F. M. Ross, H. N. Alshareef*",
        "year": 2014,
        "journal": "Small",
        "volumn": "10",
        "issue": "14",
        "pages": "2849-2858",
        "url": "<Go to ISI>://WOS:000340660900016",
        "doi": "10.1002/smll.201303898"
    },
    {
        "title": "Facile synthesis of polyaniline nanotubes using reactive oxide templates for high energy density pseudocapacitors",
        "author": "Wei Chen, R. B. Rakhi, H. N. Alshareef*",
        "year": 2013,
        "journal": "Journal of Materials Chemistry A",
        "volumn": "1",
        "issue": "10",
        "pages": "3315-3324",
        "url": "<Go to ISI>://WOS:000314784000016",
        "doi": "10.1039/c3ta00499f"
    },
    {
        "title": "Capacitance enhancement of polyaniline coated curved-graphene supercapacitors in a redox-active electrolyte",
        "author": "Wei Chen, R. B. Rakhi, H. N. Alshareef*",
        "year": 2013,
        "journal": "Nanoscale",
        "volumn": "5",
        "issue": "10",
        "pages": "4134-4138",
        "url": "<Go to ISI>://WOS:000318362400013",
        "doi": "10.1039/c3nr00773a"
    },
    {
        "title": "Morphology-Dependent Enhancement of the Pseudocapacitance of Template-Guided Tunable Polyaniline Nanostructures",
        "author": "Wei Chen, R. B. Rakhi, H. N. Alshareef*",
        "year": 2013,
        "journal": "Journal of Physical Chemistry C",
        "volumn": "117",
        "issue": "29",
        "pages": "15009-15019",
        "url": "<Go to ISI>://WOS:000322503600016",
        "doi": "10.1021/jp405300p"
    },
    {
        "title": "Effect of pH-induced chemical modification of hydrothermally reduced graphene oxide on supercapacitor performance",
        "author": "Yaocai Bai, R. B. Rakhi, Wei Chen, H. N. Alshareef*",
        "year": 2013,
        "journal": "Journal of Power Sources",
        "volumn": "233",
        "issue": "",
        "pages": "313-319",
        "url": "<Go to ISI>://WOS:000316827000043",
        "doi": "10.1016/j.jpowsour.2013.01.122"
    },
    {
        "title": "Influence of calcination temperature on the morphology and energy storage properties of cobalt oxide nanostructures directly grown over carbon cloth substrates",
        "author": "R. B. Rakhi, Wei Chen, Dongkyu Cha, H. N. Alshareef*",
        "year": 2013,
        "journal": "Materials for Renewable and Sustainable Energy",
        "volumn": "2",
        "issue": "3-4",
        "pages": "1-13",
        "url": "<Go to ISI>://INSPEC:14347287",
        "doi": "10.1007/s40243-013-0017-y"
    },

    {
        "title": "High energy density supercapacitors using macroporous kitchen sponges",
        "author": "Wei Chen, R. B. Rakhi, H. N. Alshareef*",
        "year": 2012,
        "journal": "Journal of Materials Chemistry",
        "volumn": "22",
        "issue": "29",
        "pages": "14394-14402",
        "url": "<Go to ISI>://WOS:000305966200013",
        "doi": "10.1039/c2jm32030d"
    },

    {
        "title": "Substrate Dependent Self-Organization of Mesoporous Cobalt Oxide Nanowires with Remarkable Pseudocapacitance",
        "author": "R. B. Rakhi, Wei Chen, Dongkyu Cha, H. N. Alshareef*",
        "year": 2012,
        "journal": "Nano Letters",
        "volumn": "12",
        "issue": "5",
        "pages": "2559-2567",
        "url": "<Go to ISI>://WOS:000303696400068",
        "doi": "10.1021/nl300779a"
    },
    {
        "title": "Nanostructured Ternary Electrodes for Energy-Storage Applications",
        "author": "R. B. Rakhi, Wei Chen, Dongkyu Cha, H. N. Alshareef*",
        "year": 2012,
        "journal": "Advanced Energy Materials",
        "volumn": "2",
        "issue": "3",
        "pages": "381-389",
        "url": "<Go to ISI>://WOS:000301427900014",
        "doi": "10.1002/aenm.201100609"
    },
    {
        "title": "Carbon nanotube-coated macroporous sponge for microbial fuel cell electrodes",
        "author": "Xing Xie, Meng Ye, Liangbing Hu, Nian Liu, James R. McDonough, Wei Chen, H. N. Alshareef, Craig S. Criddle*, Yi Cui*",
        "year": 2012,
        "journal": "Energy & Environmental Science",
        "volumn": "5",
        "issue": "1",
        "pages": "5265-5270",
        "url": "<Go to ISI>://WOS:000299046100016",
        "doi": "10.1039/c1ee02122b"
    },
    {
        "title": "Conducting polymer/carbon nanocoil composite electrodes for efficient supercapacitors",
        "author": "R. B. Rakhi, Wei Chen, Dongkyu Cha, H. N. Alshareef*",
        "year": 2012,
        "journal": "Journal of Materials Chemistry",
        "volumn": "22",
        "issue": "11",
        "pages": "5177-5183",
        "url": "<Go to ISI>://WOS:000300571400086",
        "doi": "10.1039/c2jm15740c"
    },
    {
        "title": "High-Performance Nanostructured Supercapacitors on a Sponge",
        "author": "Wei Chen, R. B. Rakhi, Liangbing Hu, Xing Xie, Yi Cui, H. N. Alshareef*",
        "year": 2011,
        "journal": "Nano Letters",
        "volumn": "11",
        "issue": "12",
        "pages": "5165-5172",
        "url": "<Go to ISI>://WOS:000297950200012",
        "doi": "10.1021/nl2023433"
    },
    {
        "title": "Symmetrical MnO2-Carbon Nanotube-Textile Nanostructures for Wearable Pseudocapacitors with High Mass Loading",
        "author": "Liangbing Hu#, Wei Chen#, Xing Xie, Nian Liu, Yuan Yang, Hui Wu, Yan Yao, Mauro Pasta, H. N. Alshareef, Yi Cui*",
        "year": 2011,
        "journal": "ACS Nano",
        "volumn": "5",
        "issue": "11",
        "pages": "8904-8913",
        "url": "<Go to ISI>://WOS:000297143300051",
        "doi": "10.1021/nn203085j"
    },

    {
        "title": "High performance supercapacitors using metal oxide anchored graphene nanosheet electrodes",
        "author": "R. B. Rakhi, Wei Chen, Dongkyu Cha, H. N. Alshareef*",
        "year": 2011,
        "journal": "Journal of Materials Chemistry",
        "volumn": "21",
        "issue": "40",
        "pages": "16197-16204",
        "url": "<Go to ISI>://WOS:000295580800049",
        "doi": "10.1039/c1jm12963e"
    },
    {
        "title": "Electrochemical Energy Storage Devices Using Electrodes Incorporating Carbon Nanocoils and Metal Oxides Nanoparticles",
        "author": "R. B. Rakhi, Dongkyu Cha, Wei Chen, H. N. Alshareef*",
        "year": 2011,
        "journal": "Journal of Physical Chemistry C",
        "volumn": "115",
        "issue": "29",
        "pages": "14392-14399",
        "url": "<Go to ISI>://WOS:000292892500054",
        "doi": "10.1021/jp202519e"
    },

]
export default publications;